import common from './common.js';
// 引入axios
import axios from 'axios'
axios.defaults.timeout = 10000 // 请求超时
axios.defaults.baseURL = common.baseUrl;

import router from '../../router';

import Vue from 'vue'; //引入vue
//必须实例化 Vue
let vm = new Vue();

// let urls = 'http://192.168.13.41/'
// let urls = 'http://fapi.moneyds.com/'

export default {
    GETS(url,data,success){
        let _this = this;
        axios.get(url,{
            params: data
        })
        .then(function(res){
            vm.$loading(false);
            return _this.ResAction(res,success);
        })
        .catch(function(ret){
            vm.$loading(false);
            vm.$toast('网络请求失败,请检查网络连接1');
        })
    },
    
    
    POSTS(url,data,success){
        let _this = this;
        axios.post(url,data)
        .then(function(res){
            return _this.ResAction(res,success);
        })
        .catch(function(ret){
            vm.$loading(false);
            vm.$toast('网络请求失败,请检查网络连接2');
        })
    },


    ResAction(res,success){
        if(res.data.flag == 'success'){
            if(res.data.code == 2000){
                return success(res.data);
            }
        } else if(res.data.flag == 'error'){
            //普通用户错误,提示错误信息
            if(res.data.code == 1000){
                vm.$loading(false);
                vm.$toast(res.data.msg)
            //未登录错误,跳转到引导页执行登录
            } else if(res.data.code == 1001) {
                vm.$loading(false);
                router.replace('/guide');
            //弹出签包的页面
            }else if(res.data.code == 1020) {
                vm.$popdefult(true,res.data.msg)
            }else if(res.data.code == 1021) {
                //统一用户协议弹窗
                vm.$userAgreement(true)
            } else {
                vm.$loading(false);
                vm.$toast(res.data.msg)
            }
        }
    }
}